import React from 'react';
import RegularHoursCandleNote from './RegularHoursCandleNote';

const FTFCDocs = (
    <html>
    <p>
        This is a setup that tracks full time frame continuity. This setup will
        trigger entry tactics once all of the time frames you provide us are above
        the open if long, or below the open if short.
    </p>
    <p>
        You choose these setups by manipulating the list that shows when you click
        the FTFC setup. "m" is for minute, "d" is for day, "w is for week, "M" is
        for month. The parameter candle represents the candle duration of the time
        frame. For an equity-style regular-session 60 minute candle, you would type
        in 60 for the candle parameter, and click "m" as the timeUnit.
    </p>
    <p>
        The red X button on the right will remove the associated timeFrame. The
        green plus beneath with add another timeFrame.
    </p>
    EX:
    <p>
        Let's say I want to trade AAPL, either long or short, when the 1 hour, the 1
        day, the 1 week, and the 1 month, all are the same color. I would enter as
        the setup: 60m, 1d, 1w, and 1m. If at any point, all of those time frames
        are above their respective open (the UI will show green), the setup will
        trigger long. If, at anytime, all of those time frames are below their
        respective open, it will trigger short.
    </p>
    {RegularHoursCandleNote}
    </html>
);
export default FTFCDocs;
